import * as React from 'react';
import { ListInput, BaseComponentClass, BasicCompoClassProps } from '../generic/ListInput';
import { Input } from 'semantic-ui-react';

interface UnitSensorRenameInputProps {
    onChange: (e: Event, data: {name: string, value: string}) => any;
    name: string;
    children?: (onInputChange: any) => JSX.Element | JSX.Element[];
    initialValue: Function | any;
    
}

class ConfigurationInput extends BaseComponentClass {
    
    render() {
        const { alias, name } = this.props.value || { alias: undefined, name: undefined };

        return (
            <Input
                name="name"
                defaultValue={name}
                onChange={this.onInputChange.bind(this)}
                placeholder="Renamed Name: ex:`CPU Temperature`"
                labelPosition="left"
                className="sub-inputs"
                label={<Input 
                    name="alias"
                    placeholder="Code Name. ex:`temp01`"
                    className="sub-inputs"
                    defaultValue={alias}
                    onChange={this.onInputChange.bind(this)}
                />}
            />
        );
    }
}

export default class UnitSensorRenameInput extends React.Component<UnitSensorRenameInputProps> {

    validate(_value: any): boolean | any {
        return true;
        // const { key, value } = _value;
        // const messageList: string[] = [];
        
        // if ( !key || key.length === 0) {
        //     messageList.push('key is required');
        // }

        // if (!value || value.length === 0) {
        //     messageList.push('value is required');
        // }

        // if (messageList.length > 0) {
        //     return {
        //         header: 'Invalid configuration',
        //         list: messageList
        //     };
        // }
        
    }
    handleValuesChange(values: any) {
        this.props.onChange({} as any, { name: this.props.name, value: values});
    }

    render() {
        const change = this.handleValuesChange.bind(this);

        return (
            <div>
                {this.props.children ? this.props.children(change) : null}
                <ListInput
                    initialValues={this.props.initialValue}
                    defaultValue={() => {
                        return  {
                            alias: '',
                            name: ''
                        };
                    }}
                    name={this.props.name}
                    onValuesChange={change}
                    validate={this.validate.bind(this)}
                    Item={(props: BasicCompoClassProps) => <ConfigurationInput {...props}/>}
                    StagingItem={(props: BasicCompoClassProps) => <ConfigurationInput {...props}/>}
                    addButtonText="Add Configuration"
                />
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/inputs/UnitSensorRenaming.tsx